export enum LotteryTypeId {
  KLASSISCH = 1,
  ERWEITERT = 2,
}
